import 'fomantic-ui-dropdown/dropdown'
import 'fomantic-ui-transition/transition'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    $(this.element).dropdown({
      allowAdditions: true,
      hideAdditions: false,
      message: { addResult: '{term}' },
      hideDividers: 'empty',
      preserveHTML: true,
      onShow: () => setTimeout(() => (this.menu.scrollTop = 0), 30),
      forceSelection: true
    })
    this.adjustDropdownElements()
  }

  get menu() {
    return this.element.parentElement.querySelector('.menu')
  }

  // Convert existing select to menu taking into account <optgroup>s
  convertOptgroupedMenu() {
    const menu = this.menu
    const newMenu = document.createElement('div')
    newMenu.classList.add('menu')

    this.element.querySelectorAll('optgroup').forEach((optgroup, index) => {
      const header = document.createElement('div')
      header.classList.add('header', 'text-base', 'text-black/35', 'font-normal', 'normal-case', 'italic')
      header.innerHTML = optgroup.label
      newMenu.appendChild(header)
      optgroup.querySelectorAll('option').forEach((option, i) => {
        const item = document.createElement('div')
        item.classList.add('item', 'md:pl-12', 'text-truncate', 'w-full')
        if (option.selected) {
          item.classList.add('active', 'selected')
        }
        item.dataset.value = option.value
        item.innerHTML = option.innerHTML.replace(/\(([^)]+)\)/g, '<em class="text-gray-700/30">($1)</em>')
        newMenu.appendChild(item)
      })
    })

    menu.innerHTML = newMenu.innerHTML
    menu.classList.add('max-h-96')
  }

  adjustDropdownElements() {
    const search = this.element.parentElement.querySelector('input.search')
    if (search) {
      this.setInputFilter(search, value => /^0*\d{0,6}$/.test(value))
      search.inputMode = 'none'
      if (this.element.getAttribute('autofocus') === 'true') {
        search.focus()
      }
      if (this.element.querySelectorAll('optgroup').length > 0) {
        this.convertOptgroupedMenu()
      }
    } else {
      setTimeout(() => this.adjustDropdownElements(), 50)
    }
  }

  // Restricts input for the given textbox to the given inputFilter function.
  setInputFilter(textbox, inputFilter) {
    const filteredEvents = ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop']
    filteredEvents.forEach(event => {
      textbox.addEventListener(event, function () {
        if (inputFilter(this.value)) {
          this.oldValue = this.value
          this.oldSelectionStart = this.selectionStart
          this.oldSelectionEnd = this.selectionEnd
        } else if (Object.prototype.hasOwnProperty.call(this, 'oldValue')) {
          this.value = this.oldValue
          this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd)
        } else {
          this.value = ''
        }
      })
    })
  }
}
